import { render, staticRenderFns } from "./platttask-info.vue?vue&type=template&id=fa6a8caa&"
import script from "./platttask-info.vue?vue&type=script&lang=js&"
export * from "./platttask-info.vue?vue&type=script&lang=js&"
import style0 from "./platttask-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports